import { call, put, takeLatest } from 'redux-saga/effects';
import {
    createApiActionCreators,
    createActionCreator,
    createReducer,
    createActionType,
    REQUEST,
    SUCCESS,
    FAILURE,
} from '../../../common/utils/reduxHelpers';
import { combineReducers } from 'redux';
import transactionsApi from '../api';
import message from 'antd/lib/message';
import { t } from '../../../app/i18n';
  
export const FETCH_TRANSACTIONS = 'transactions/FETCH_TRANSACTIONS';
export const FETCH_TRANSACTIONS_PREVIEW = 'transactions/FETCH_TRANSACTIONS_PREVIEW';
export const FETCH_TRANSACTIONS_SUMMARY = 'transactions/FETCH_TRANSACTIONS_SUMMARY';
export const FETCH_REPORT = 'transactions/FETCH_REPORT';

export const FETCH_EXTERNAL_PENDING_TRANSACTIONS = 'externalTransaction/FETCH_EXTERNAL_PENDING_TRANSACTIONS';
export const DELETE_EXTERNAL_TRANSACTION = 'externalTransaction/DELETE_EXTERNAL_TRANSACTION';

export const fetchTransactionsAction = createApiActionCreators(FETCH_TRANSACTIONS);
export const fetchTransactionsPreviewAction = createApiActionCreators(FETCH_TRANSACTIONS_PREVIEW);
export const fetchExternalPendingTransactionsAction = createApiActionCreators(FETCH_EXTERNAL_PENDING_TRANSACTIONS);
export const deleteExternalTransactionByIdAction = createApiActionCreators(DELETE_EXTERNAL_TRANSACTION);
export const fetchTransactionSummaryPerAccountIdAction = createApiActionCreators(FETCH_TRANSACTIONS_SUMMARY);
export const fetchReportActions = createApiActionCreators(FETCH_REPORT);

const initialState = {
    transactions: {
        items: [],
        pagination: {
            current: 1,
            pageSize: 20,
            total: 0,
        },
        filter: {
            transactionId: "",
            AccountFrom: "",
            AccountTo: "",
            Amount: [],
            Type: "",
            TransactionDateAt: [],
            LoanNumber: "",
            InvestmentNumber: "",
            VS: ""
        },
        isLoading: true,
    },
    externalTransactions:{
        items:[],
        pagination: {
            current: 1,
            pageSize: 20,
            total: 0,
        },
        isLoading: false,
    },
    preview: {
        items:[],
        pagination: {
            current: 1,
            pageSize: 20,
            total: 0,
        },
        isLoading: false,
        filter: {
            VS: "",
            InvestmentNumber: "",
            Amount: [],
            Type: "",
            TransactionDateAt: [],
        },
        summary: {

        }
    },
    controlJobResult: null,

};

const transactions = createReducer(initialState.transactions, {
    [FETCH_TRANSACTIONS] : {
        [REQUEST]: (state, payload) => ({
            ...state,
            isLoading: true
        }),
        [SUCCESS]: (state, payload) => ({
            ...state,
            items: payload.items,
            pagination: payload.pagination,
            filter: payload.filter,
            isLoading: false
        }),
        [FAILURE]: (state) => ({
            ...state,
            isLoading: false
        }),
    },
});

const externalTransactions = createReducer(initialState.externalTransactions, {
    [FETCH_EXTERNAL_PENDING_TRANSACTIONS] : {
        [REQUEST]: (state, payload) => ({
            ...state,
            isLoading: true
        }),
        [SUCCESS]: (state, payload) => ({
            ...state,
            items: payload.items,
            pagination: payload.pagination,
            //filter: payload.filter,
            isLoading: false
        }),
        [FAILURE]: (state) => ({
            ...state,
            isLoading: false
        }),
    },
    [DELETE_EXTERNAL_TRANSACTION]: {
        [REQUEST]: (state, payload) => ({
            ...state,
            isLoading: true
        }),
        [FAILURE]: (state) => ({
            ...state,
            isLoading: false
        }),
    }
});

const preview = createReducer(initialState.preview, {
    [FETCH_TRANSACTIONS_PREVIEW] : {
        [REQUEST]: (state, payload) => ({
            ...state,
            isLoading: true
        }),
        [SUCCESS]: (state, payload) => ({
            ...state,
            items: payload.items,
            pagination: payload.pagination,
            filter: payload.filter,
            isLoading: false
        }),
        [FAILURE]: (state) => ({
            ...state,
            isLoading: false
        }),
    },
    [FETCH_TRANSACTIONS_SUMMARY] : {
        [REQUEST]: (state, payload) => ({
            ...state,
            isLoading: true
        }),
        [SUCCESS]: (state, payload) => ({
            ...state,
            summary: payload.summary,
            isLoading: false
        }),
        [FAILURE]: (state) => ({
            ...state,
            isLoading: false
        }),
    },
});

const controlJobResult = createReducer(initialState.controlJobResult, {
    [FETCH_REPORT]: {
        [SUCCESS]: (state, payload) => payload,
        [FAILURE]: (state, payload) => null 
    }
})

export default combineReducers({
    transactions,
    externalTransactions,
    preview,
    controlJobResult
});

export const selectTransactionState = state => state.transactions.transactions;
export const selectTransactions = state => selectTransactionState(state).items;
export const selectPagination = state => selectTransactionState(state).pagination;
export const selectFilter = state => selectTransactionState(state).filter;
export const selectIsLoading = state => selectTransactionState(state).isLoading;

export const selectTransactionPreviewState = state => state.transactions.preview;
export const selectPreviewTransactions = state => selectTransactionPreviewState(state).items;
export const selectPreviewTransactionsPagination = state => selectTransactionPreviewState(state).pagination;
export const selectPreviewTransactionsFilter = state => selectTransactionPreviewState(state).filter;
export const selectPreviewTransactionsIsLoading = state => selectTransactionPreviewState(state).isLoading;
export const selectPreviewTransactionsSummary = state => selectTransactionPreviewState(state).summary;

export const selectExternalTransactionState = state => state.transactions.externalTransactions;
export const selectExternalTransaction = state => selectExternalTransactionState(state).items;
export const selectExternalTransactionPagination = state =>  selectExternalTransactionState(state).pagination;
export const selectExternalTransactionIsLoading = state => selectExternalTransactionState(state).isLoading;
export const selectResultState = state => state.transactions.controlJobResult;
export const selectResult = state => selectResultState(state).items


function* fetchTransactions({payload}) {
    const resp = yield call(transactionsApi.fetchTransactions, payload);

    if (resp.ok) {
        yield put(fetchTransactionsAction.success({
            items: resp.data.items,
            pagination: resp.data.pagination,
            filter: payload.filter
        }));
    }
    if (resp.error) {
        yield put(fetchTransactionsAction.failure());
    }
}

function* fetchExternalPendingTransactions({payload}) {
    const resp = yield call(transactionsApi.fetchPendingTransactions, payload);

    if (resp.ok) {
        yield put(fetchExternalPendingTransactionsAction.success({
            items: resp.data.items,
            pagination: resp.data.pagination
        }));
    }
    if (resp.error) {
        yield put(fetchExternalPendingTransactionsAction.failure());
    }
}

function* deleteExternalTransaction({payload}) {
    const {id, pagination} = payload;
    const resp = yield call(transactionsApi.deleteExternalTransaction, id);

    if (resp.ok){
        message.success(`${t('Transakcia bola zmazaná')}.`, 5);
        yield put(fetchExternalPendingTransactionsAction.request({pagination}));
    }
    if (resp.error){
        yield put(deleteExternalTransactionByIdAction.failure());
    }
}

function* fetchTransactionsPreview({payload}) {
    const resp = yield call(transactionsApi.fetchTransactionsPreview, payload);

    if (resp.ok) {
        yield put(fetchTransactionsPreviewAction.success({
            items: resp.data.items,
            summary: resp.data.summary,
            pagination: resp.data.pagination,
            filter: payload.options.filter,
        }));
    }
    if (resp.error) {
        yield put(fetchTransactionsPreviewAction.failure());
    }
}

function* fetchTransactionsSummary({payload}) {
    const resp = yield call(transactionsApi.fetchTransactionsSummary, payload);
    if (resp.ok) {
        yield put(fetchTransactionSummaryPerAccountIdAction.success({
            summary: resp.data.summary,
        }));
    }
    if (resp.error) {
        yield put(fetchTransactionSummaryPerAccountIdAction.failure());
    }
}

function* fetchResult(){
    const resp = yield call(transactionsApi.fetchReport);
    if(resp.ok) {
        yield put(fetchReportActions.success(resp.data))
    }
    else {
        yield put(fetchReportActions.failure(resp.error))
    }
}

export function* transactionSaga() {
    yield takeLatest(createActionType(FETCH_TRANSACTIONS, REQUEST), fetchTransactions);
    yield takeLatest(createActionType(FETCH_TRANSACTIONS_PREVIEW, REQUEST), fetchTransactionsPreview);
    yield takeLatest(createActionType(FETCH_EXTERNAL_PENDING_TRANSACTIONS, REQUEST), fetchExternalPendingTransactions);
    yield takeLatest(createActionType(DELETE_EXTERNAL_TRANSACTION, REQUEST), deleteExternalTransaction);
    yield takeLatest(createActionType(FETCH_TRANSACTIONS_SUMMARY, REQUEST), fetchTransactionsSummary);
    yield takeLatest(createActionType(FETCH_REPORT, REQUEST), fetchResult)
}


// WEBPACK FOOTER //
// ./src/features/transactions/ducks/index.js